import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=68164d62&scoped=true&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaymentSuccess.vue?vue&type=style&index=0&id=68164d62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68164d62",
  null
  
)

export default component.exports